module.exports = __webpack_public_path__ + "static/media/Initiative.14ddbe02.png";